<template>
    <div class="table-layout">
        <el-table :data="servcWorkVoucherRecList" border style="width: 100%">
            <el-table-column prop="actorName" label="操作人" width="150" align="left"></el-table-column>
            <el-table-column prop="action" label="动作" width="100" align="left"></el-table-column>
            <el-table-column prop="actRole" label="操作人身份" width="120" align="left"></el-table-column>
            <el-table-column prop="extraInfo" label="附加信息" show-overflow-tooltip align="left"></el-table-column>
            <el-table-column prop="loc" label="操作位置" width="200" show-overflow-tooltip align="left"></el-table-column>
            <el-table-column prop="ts" label="操作时间" align="center" width="160"></el-table-column>
        </el-table>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-servc-work-voucher-rec-list',
        desc: '工单操作记录',
        props: ['voucherId'],
        data: function () {
            return {
                servcWorkVoucherRecList: [],
            }
        },
        created: function () {
            this.getServcWorkVoucherRecList();
        },
        methods: {
            getServcWorkVoucherRecList: function () {
                let self = this;
                let params = {};
                params.workVoucherId = self.voucherId;
                servcDelivApi.getServcWorkVoucherRecListByWorkVoucherId(params, function (result) {
                    if(result.type === "info") {
                        self.servcWorkVoucherRecList = result.data;
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherRecList.vue